enum BankRegnr {
    EIKA = '0770',
    EKF = '0501',
}

export const isMalbankBankRegnr = (bankregnr: string) => bankregnr !== BankRegnr.EIKA && bankregnr !== BankRegnr.EKF;
